interface SelectDaysProps {
  value: number | 'custom' | 'all';
  onChange: (days: number | 'custom' | 'all') => void;
}

const SelectDays = ({ value, onChange }: SelectDaysProps) => {
  return (
    <select
      className="select-days-component-container"
      value={value}
      onChange={(e) => {
        const val = e.target.value;
        onChange(val === 'custom' || val === 'all' ? val : Number(val));
      }}
      style={{
        padding: '5px 10px',
        borderRadius: '8px',
        border: '1px solid #ddd',
        fontSize: '0.9rem',
        cursor: 'pointer',
        outline: 'none',
        background: '#fff'
      }}
    >
      <option value="all">All Time</option>
      <option value={1}>Today</option>
      <option value={7}>Last 7 days</option>
      <option value={30}>Last 30 days (1 Month)</option>
      <option value={180}>Last 6 Months</option>
      <option value="custom">Custom Range</option>
    </select>
  )
}

export default SelectDays